function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "uploadAudio_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "uploadAudio_svg__a",
  transform: "translate(63 171)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "uploadAudio_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "uploadAudio_svg__c",
  d: "M9.25 21a.75.75 0 010-1.5h2v-1.55A6 6 0 016 12V9.25a.75.75 0 111.5 0V12a4.5 4.5 0 009 0V9.25a.75.75 0 111.5 0V12a6 6 0 01-5.25 5.95v1.55h2a.75.75 0 110 1.5zM9 12V5a3 3 0 016 0v7a3 3 0 01-6 0z"
}));

function SvgUploadAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgUploadAudio;